/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Locked_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Record locked successfully" |
*
* @param {Explorer_Info_Locked_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_locked_success_toast = /** @type {((inputs?: Explorer_Info_Locked_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Locked_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement verrouille avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datensatz erfolgreich gesperrt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Record bloccato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запись успешно заблокирована.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registro bloqueado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("记录已成功锁定")
	if (locale === "ja") return /** @type {LocalizedString} */ ("レコードが正常にロックされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्ड सफलतापूर्वक लॉक हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Registro bloqueado com sucesso")
	return /** @type {LocalizedString} */ ("Record locked successfully")
});